exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SelectVcDemo h4[data-v-20af76e8]{color:#066}.SelectVcDemo .demoItem[data-v-20af76e8]{padding:10px 0;border-bottom:1px dotted #999}.SelectVcDemo .demoItem .demoText[data-v-20af76e8]{margin:15px 10px 5px}", ""]);

// exports
